import {
  CHANGE_COLOR,
  CLEAR_DRAW,
} from '../actions/types';

export default function (state = {color:'blue',color1:'blue',color2:'red',clear:false}, action) {
    switch (action.type) {
    case CHANGE_COLOR:
        return action.payload;
    case CLEAR_DRAW:
        return action.payload;
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/app/reducers/ts_overlay.js